import { difference } from 'lodash';
import * as ast from '../../generated/ast.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
// Check that the node values matches the values in the commands metadata
// eslint-disable-next-line max-params
export function validateCommandsMetadata(node, nodeFields, services, accept) {
    const { idField, commandField, nodeTypeField, outputField, decisionVariableField, parameterInputField, } = nodeFields;
    // commands metadata validation is only for action nodes
    if (nodeTypeField?.nodeType?.value === 'D')
        return;
    const command = commandField?.command?.value;
    const commandsMetadata = services.commandsMetadataService.getCommandsMetadata();
    if (!command || !commandsMetadata)
        return;
    // Check if this command exists in the metadata.
    // Generate a warning if it does not exist
    const commandMetadata = commandsMetadata.find((cmd) => cmd.commandName === command);
    if (!commandMetadata) {
        accept('warning', `Missing implementation for command '${command}' in the services directory.`, {
            node: commandField,
            data: {
                id: idField?.id?.value,
                nodeNumber: node?.name,
                propertyName: FRONTEND_PROPERTY_NAME.COMMAND,
            },
        });
        return;
    }
    if (outputField) {
        // Check the output field to ensure that it matches the output of the
        // command as defined by the command metadata
        const output = outputField.output.map((o) => o.value);
        const missingOutput = difference(commandMetadata.output, output);
        const extraOutput = difference(output, commandMetadata.output);
        if (missingOutput.length > 0 || extraOutput.length > 0) {
            accept('warning', `Output from the service '${command}' does not match the variables listed in the output field.`, {
                node: outputField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.OUTPUT,
                },
            });
        }
    }
    if (decisionVariableField) {
        // Check the decision variable field to ensure that it matches the output of the
        // command as defined by the command metadata
        const decisionVariable = ast.isStringField(decisionVariableField.decisionVariable)
            ? decisionVariableField.decisionVariable.value
            : '';
        if (commandMetadata.output.indexOf(decisionVariable) === -1) {
            accept('warning', `Decision variable '${decisionVariable}' is not being returned from the service '${command}'.`, {
                node: decisionVariableField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.DECISION_VARIABLE,
                },
            });
        }
    }
    if (parameterInputField) {
        let input = [];
        if (ast.isGenericJsonObject(parameterInputField.parameterInput)) {
            input = parameterInputField.parameterInput.members.map((member) => member.key.value);
        }
        const missingInput = difference(commandMetadata.input, input);
        if (missingInput.length > 0) {
            accept('warning', `Input parameters for the service '${command}' does not match the value in the parameterInput field.`, {
                node: parameterInputField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.PARAMETER_INPUT,
                },
            });
        }
    }
}
//# sourceMappingURL=validate-commands-metadata.js.map